import * as BABYLON from 'babylonjs';

class BasicComponent {

    constructor( { id, situationID, rootNode = null } = {} ) {
        Object.assign( this, { id, situationID } );

        this.rootNode = rootNode;
        this.prefab = undefined;
    }

    getType() { return "BasicComponent"; }

    setID( id ) { this.id = id; return this; }
    getID() { return this.id; }
    getSituationID() { return this.situationID; }
    getRootNode() { return this.rootNode; }

    setSituationID( id ) { this.situationID = id; return this; }
    setRootNode( node ) { this.rootNode = node; return this; }

    // Constructs scene graph elements based on this component...
    construct( context, prefab ) {
        this.setSituationID( prefab.getSituationID() );
        this.setRootNode( new BABYLON.TransformNode(prefab.getType() + "_" + prefab.getID(), window.scene) );
        this.prefab = prefab;
        return this;
    }

    // Update this component...
    update( context = {} ) {
        if(context === 42){
            console.log("42");
        }
    }

    // Enable this component in the scene graph
    enable() {
        if( this.rootNode )
            this.rootNode.setEnabled( true );
    }

    // Disable this component in the scene graph
    disable() {
        if( this.rootNode )
            this.rootNode.setEnabled( false );
    }

    // Destructs the scene graph for this component
    destruct() {
        if( this.rootNode )
            this.rootNode.dispose();
    }

    play(){
    }

    pause(){
    }

    stop(){
    }

    reset(){
    }

    jumpToTimePosition(timeToJumpTo){
    }

    changeVolume(volume){
    }

    isPlaying(){
    }

    isMute(){
    }
}

export default BasicComponent;
